import { graphql } from "~/gql";

export const FEE_EARNER_LEVELS_AND_FEE_EARNERS_QUERY = graphql(/* GraphQL */ `
  query FeeEarnerLevelsAndFeeEarners {
    feeEarnerLevels {
      records {
        id
        order
        description
        externalReference
        feeEarners {
          id
          name
        }
      }
    }
  }
`);
